module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "admin-orders"
  }, [_c('v-layout', {
    staticClass: "row"
  }, [_c('v-flex', {
    staticClass: "mb-5"
  }, [_c('filter-bar', {
    attrs: {
      "search": _vm.search
    },
    on: {
      "filterOrders": function($event) {
        return _vm.filterOrders($event)
      },
      "search": function($event) {
        return _vm.searchFor($event)
      }
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "orders-list"
  }, [_c('v-layout', {
    staticClass: "row"
  }, [_c('v-flex', {
    staticClass: "xs12"
  }, [_c('table', {
    staticClass: "fancy white-background"
  }, [_c('thead', [_c('tr', [_c('th', {
    staticClass: "line-num"
  }), _vm._v(" "), _c('th', {
    staticClass: "left-align nowrap",
    attrs: {
      "width": "1"
    }
  }, [_vm._v("Order #")]), _vm._v(" "), _c('th', {
    staticClass: "left-align hidden-sm-and-down",
    attrs: {
      "width": "95px"
    }
  }, [_vm._v("Started")]), _vm._v(" "), _c('th', {
    staticClass: "left-align hidden-sm-and-down",
    attrs: {
      "width": "95px"
    }
  }, [_vm._v("Ordered")]), _vm._v(" "), _c('th', {
    staticClass: "left-align hidden-sm-and-down",
    attrs: {
      "width": "95px"
    }
  }, [_vm._v("Production")]), _vm._v(" "), _c('th', {
    staticClass: "left-align hidden-md-and-down",
    attrs: {
      "width": "95px"
    }
  }, [_vm._v("Shipped")]), _vm._v(" "), _c('th', {
    staticClass: "left-align hidden-md-and-down",
    attrs: {
      "width": "95px"
    }
  }, [_vm._v("Delivered")]), _vm._v(" "), _c('th', {
    staticClass: "left-align nowrap"
  }, [_vm._v("Items")]), _vm._v(" "), _c('th', {
    staticClass: "left-align nowrap hidden-md-and-down",
    attrs: {
      "width": "1"
    }
  }, [_vm._v("Qty")]), _vm._v(" "), _c('th', {
    staticClass: "left-align nowrap hidden-md-and-down",
    attrs: {
      "width": "200"
    }
  }, [_vm._v("Ship To")]), _vm._v(" "), _c('th', {
    staticClass: "left-align nowrap hidden-md-and-down",
    attrs: {
      "width": "200"
    }
  }, [_vm._v("Bill To")]), _vm._v(" "), _c('th', {
    staticClass: "center-align",
    attrs: {
      "width": "1"
    }
  }, [_vm._v("Actions")])])]), _vm._v(" "), _c('tbody', [(_vm.orders.length <= 0) ? _c('tr', [_c('td', {
    staticClass: "line-num"
  }), _vm._v(" "), _c('td', {
    staticClass: "center-align",
    attrs: {
      "colspan": "11"
    }
  }, [_vm._v("No orders found.")])]) : _vm._e(), _vm._v(" "), _vm._l((_vm.orders), function(order, index) {
    return _c('tr', [_c('td', {
      staticClass: "line-num"
    }, [_vm._v(_vm._s(index + 1))]), _vm._v(" "), _c('td', {
      staticClass: "nowrap"
    }, [_c('v-tooltip', {
      attrs: {
        "bottom": "bottom"
      }
    }, [_c('a', {
      attrs: {
        "slot": "activator",
        "href": '/orders/' + order.id,
        "target": "_blank"
      },
      slot: "activator"
    }, [_vm._v(_vm._s(order.site_code) + _vm._s(order.id))]), _vm._v(" "), _c('span', [_vm._v("Order Process: " + _vm._s(order.process || 'None'))])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('span', {
      staticClass: "allcaps",
      attrs: {
        "slot": "activator",
        "href": '/admin/users/' + order.user_id
      },
      slot: "activator"
    }, [_vm._v(_vm._s(order.affiliate_id || order.site_code))]), _vm._v(" "), _c('v-tooltip', {
      attrs: {
        "bottom": "bottom"
      }
    }, [_c('a', {
      attrs: {
        "slot": "activator",
        "href": '/admin/users/' + order.user_id
      },
      slot: "activator"
    }, [_vm._v(_vm._s(order.user_id))]), _vm._v(" "), _c('span', [_vm._v(_vm._s(order.email))])])], 1), _vm._v(" "), _c('td', {
      staticClass: "center-align nowrap hidden-sm-and-down"
    }, [(order.created_at) ? _c('div', {
      staticClass: "caption"
    }, [_c('span', [_vm._v(_vm._s(_vm._f("moment")(order.created_at, 'timezone', 'America/Los_Angeles', 'MM/DD/YYYY')))]), _vm._v(" "), _c('br'), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.displayTime(order.created_at)))])]) : _vm._e()]), _vm._v(" "), _c('td', {
      staticClass: "center-align nowrap hidden-sm-and-down"
    }, [(order.ordered_at) ? _c('div', {
      staticClass: "caption"
    }, [_c('span', [_vm._v(_vm._s(_vm._f("moment")(order.ordered_at, 'timezone', 'America/Los_Angeles', 'MM/DD/YYYY')))]), _vm._v(" "), _c('br'), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.displayTime(order.ordered_at)))])]) : _vm._e()]), _vm._v(" "), _c('td', {
      staticClass: "center-align nowrap"
    }, [(order.processed_at) ? _c('div', {
      staticClass: "caption"
    }, [_c('span', [_vm._v(_vm._s(_vm._f("moment")(order.processed_at, 'timezone', 'America/Los_Angeles', 'MM/DD/YYYY')))]), _vm._v(" "), _c('br'), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.displayTime(order.processed_at)))])]) : _vm._e()]), _vm._v(" "), _c('td', {
      staticClass: "center-align nowrap hidden-md-and-down"
    }, [(_vm.shouldHaveShipped(order)) ? [_c('v-icon', {
      attrs: {
        "color": "red"
      }
    }, [_vm._v("mdi-alert")]), _vm._v(" "), _c('div', {
      staticClass: "caption"
    }, [_vm._v(_vm._s(_vm._f("moment")(order.expected_to_ship, 'timezone', 'America/Los_Angeles', 'MM/DD/YYYY')))])] : (order.shipped_at) ? _c('div', {
      staticClass: "caption"
    }, [_c('span', [_vm._v(_vm._s(_vm._f("moment")(order.shipped_at, 'timezone', 'America/Los_Angeles', 'MM/DD/YYYY')))]), _vm._v(" "), _c('br'), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.displayTime(order.shipped_at)))])]) : (order.processed_at) ? _c('div', {
      staticClass: "caption"
    }, [_vm._v("Exp Ship\n"), _c('br'), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm._f("moment")(order.expected_to_ship, 'timezone', 'America/Los_Angeles', 'MM/DD/YYYY')))])]) : _vm._e()], 2), _vm._v(" "), _c('td', {
      staticClass: "center-align nowrap hidden-md-and-down"
    }, [(order.delivered_at) ? _c('div', {
      staticClass: "caption"
    }, [_c('span', [_vm._v(_vm._s(_vm._f("moment")(order.delivered_at, 'timezone', 'America/Los_Angeles', 'MM/DD/YYYY')))]), _vm._v(" "), _c('br'), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.displayTime(order.delivered_at)))])]) : (order.expected_at) ? _c('div', {
      staticClass: "caption"
    }, [_vm._v("Exp Del\n"), _c('br'), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm._f("moment")(order.expected_at, 'timezone', 'America/Los_Angeles', 'MM/DD/YYYY')))])]) : _vm._e()]), _vm._v(" "), _c('td', [_vm._l((order.items), function(item) {
      return _c('div', {
        staticClass: "admin-order-items"
      }, [_c('div', {
        staticClass: "left mt-1"
      }, [_c('v-tooltip', {
        attrs: {
          "bottom": "bottom"
        }
      }, [_c('a', {
        attrs: {
          "slot": "activator",
          "href": item.file.files.preview,
          "target": "_blank"
        },
        slot: "activator"
      }, [_c('img', {
        staticClass: "mr-2 border v-align thumbnail",
        attrs: {
          "src": item.file.thumbs.small
        }
      })]), _vm._v(" "), _c('span', [_vm._v(_vm._s(item.name || 'Unknown'))])])], 1), _vm._v(" "), _c('div', [_c('div', [_vm._v(_vm._s((item.name || 'Unknown')))]), _vm._v(" "), _c('detail-modal', {
        attrs: {
          "item": item
        }
      }, [_vm._v("Details")])], 1)])
    }), _vm._v(" "), (order.items.length == 0) ? _c('span', [_vm._v("No Items Found")]) : _vm._e()], 2), _vm._v(" "), _c('td', {
      staticClass: "nowrap hidden-md-and-down"
    }, [_vm._l((order.items), function(item) {
      return [_c('div', {
        staticClass: "right"
      }, [_vm._v(_vm._s(item.quantity))])]
    })], 2), _vm._v(" "), _c('td', {
      staticClass: "hidden-md-and-down"
    }, [(order.customer) ? _c('v-tooltip', {
      attrs: {
        "bottom": "bottom"
      }
    }, [_c('div', {
      attrs: {
        "slot": "activator"
      },
      slot: "activator"
    }, [_c('div', {
      staticClass: "caption"
    }, [_vm._v(_vm._s(_vm.fullName(order.shipping_info)))]), _vm._v(" "), _c('div', {
      staticClass: "caption"
    }, [_vm._v(_vm._s(_vm.companyName(order.shipping_info)))])]), _vm._v(" "), _c('span', [_vm._v(_vm._s(order.customer.ship_add1))]), _vm._v(" "), (order.customer.ship_add2) ? _c('br') : _vm._e(), _vm._v(_vm._s(order.customer.ship_add2) + "\n"), _c('br'), _vm._v(_vm._s(order.customer.ship_city) + ", " + _vm._s(order.customer.ship_state) + " " + _vm._s(order.customer.ship_zip))]) : _vm._e()], 1), _vm._v(" "), _c('td', {
      staticClass: "hidden-md-and-down"
    }, [(order.customer) ? _c('v-tooltip', {
      attrs: {
        "bottom": "bottom"
      }
    }, [_c('div', {
      attrs: {
        "slot": "activator"
      },
      slot: "activator"
    }, [_c('div', {
      staticClass: "caption"
    }, [_vm._v(_vm._s(_vm.fullName(order.billing_info)))]), _vm._v(" "), _c('div', {
      staticClass: "caption"
    }, [_vm._v(_vm._s(_vm.companyName(order.billing_info)))])]), _vm._v(" "), _c('span', [_vm._v(_vm._s(order.customer.add1))]), _vm._v(" "), (order.customer.add2) ? _c('br') : _vm._e(), _vm._v(_vm._s(order.customer.add2) + "\n"), _c('br'), _vm._v(_vm._s(order.customer.city) + ", " + _vm._s(order.customer.state) + " " + _vm._s(order.customer.zip))]) : _vm._e()], 1), _vm._v(" "), _c('td', {
      staticClass: "nowrap center-align"
    }, [_c('div', {
      staticClass: "btn-group"
    }, [_c('v-tooltip', {
      attrs: {
        "bottom": "bottom"
      }
    }, [_c('v-btn', {
      attrs: {
        "slot": "activator",
        "disabled": "disabled",
        "icon": "icon"
      },
      slot: "activator"
    }, [_c('v-icon', [_vm._v("mdi-credit-card")])], 1), _vm._v(" "), _c('span', [_vm._v("Payment Details")])], 1), _vm._v(" "), (order.shipping_status.shipping_link) ? _c('v-tooltip', {
      attrs: {
        "bottom": "bottom"
      }
    }, [_c('v-btn', {
      attrs: {
        "slot": "activator",
        "icon": "icon",
        "href": order.shipping_status.shipping_link,
        "target": "_blank"
      },
      slot: "activator"
    }, [_c('v-icon', [_vm._v("fab fa-" + _vm._s(order.shipping_carrier.toLowerCase()))])], 1), _vm._v(" "), _c('span', [_vm._v(_vm._s(order.shipping_method_short_name))])], 1) : _c('v-btn', {
      attrs: {
        "disabled": "disabled",
        "icon": "icon"
      }
    }, [_c('v-icon', [_vm._v("mdi-truck")])], 1), _vm._v(" "), (order.processed_at && order.status_id !== 3) ? _c('v-tooltip', {
      attrs: {
        "bottom": "bottom"
      }
    }, [_c('v-btn', {
      attrs: {
        "slot": "activator",
        "icon": "icon"
      },
      on: {
        "click": function($event) {
          return _vm.resubmitOrder(order)
        }
      },
      slot: "activator"
    }, [_c('v-icon', [_vm._v("mdi-redo")])], 1), _vm._v(" "), _c('span', [_vm._v("Resubmit Order (Same #)")])], 1) : (order.ordered_at && order.status_id !== 3) ? _c('v-tooltip', {
      attrs: {
        "bottom": "bottom"
      }
    }, [_c('v-btn', {
      attrs: {
        "slot": "activator",
        "icon": "icon"
      },
      on: {
        "click": function($event) {
          return _vm.submitOrder(order)
        }
      },
      slot: "activator"
    }, [_c('v-icon', [_vm._v("mdi-send")])], 1), _vm._v(" "), _c('span', [_vm._v("Submit Order")])], 1) : _c('v-btn', {
      attrs: {
        "disabled": "disabled",
        "icon": "icon"
      }
    }, [_c('v-icon', [_vm._v("mdi-send")])], 1), _vm._v(" "), (order.ordered_at) ? _c('v-tooltip', {
      attrs: {
        "bottom": "bottom"
      }
    }, [_c('v-btn', {
      attrs: {
        "slot": "activator",
        "icon": "icon"
      },
      on: {
        "click": function($event) {
          return _vm.replaceOrder(order)
        }
      },
      slot: "activator"
    }, [_c('v-icon', [_vm._v("mdi-autorenew")])], 1), _vm._v(" "), _c('span', [_vm._v("Replacement Order (No Cost)")])], 1) : _c('v-btn', {
      attrs: {
        "disabled": "disabled",
        "icon": "icon"
      }
    }, [_c('v-icon', [_vm._v("mdi-autorenew")])], 1), _vm._v(" "), (!order.processed_at && order.status_id !== 3) ? _c('v-tooltip', {
      attrs: {
        "bottom": "bottom"
      }
    }, [_c('v-btn', {
      attrs: {
        "slot": "activator",
        "icon": "icon"
      },
      on: {
        "click": function($event) {
          return _vm.cancelOrder(order)
        }
      },
      slot: "activator"
    }, [_c('v-icon', [_vm._v("mdi-close-circle")])], 1), _vm._v(" "), _c('span', [_vm._v("Cancel Order")])], 1) : (order.status_id === 3) ? _c('v-tooltip', {
      attrs: {
        "bottom": "bottom"
      }
    }, [_c('v-btn', {
      attrs: {
        "slot": "activator",
        "icon": "icon"
      },
      on: {
        "click": function($event) {
          return _vm.reinstateOrder(order)
        }
      },
      slot: "activator"
    }, [_c('v-icon', [_vm._v("mdi-restore")])], 1), _vm._v(" "), _c('span', [_vm._v("Reinstate Order")])], 1) : _c('v-btn', {
      attrs: {
        "disabled": "disabled",
        "icon": "icon"
      }
    }, [_c('v-icon', [_vm._v("mdi-close-circle")])], 1)], 1)])])
  })], 2)])])], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2c1c5315","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=haml!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/admin/orders/index.vue
// module id = 638
// module chunks = 1